<template>
	<vxe-modal v-model="importNoticeShow" confirm-button-text="确认导入" show-footer height="600" width="1200"
		destroy-on-close :loading="importLoading" @show="modalShow" @hide="modalHide">
		<template #title>
			<span>导入面板</span>
		</template>
		<template #default>
			<el-radio-group v-model="importconfigid" style="margin:10px 0px;" @change="importconfigidChange">
				<el-radio v-for="(item,index) in importConfig" :label="item.id" :key="index" size="mini" >{{item.name+'【'+item.configtext+'】'}}</el-radio>
			</el-radio-group>
			<vxe-grid v-if="list_gridOptions" v-bind="list_gridOptions"
				@toolbar-button-click="list_toolbarButtonClickEvent" :ref="importTableRef"></vxe-grid>
		</template>
		<template #footer>
			<div v-if="importSourceConfig.length">
				<vxe-button status="primary" @click="importApi(0)">确认导入</vxe-button>
				<vxe-button @click="importNoticeShow = false">返回</vxe-button>
			</div>
		</template>
	</vxe-modal>
</template>
<style>

</style>
<style scoped>

</style>
<script>
	import listMixins from '@_system/components/base/mixins/list/list.js'
	export default {
		mixins: [listMixins],
		props: {
			componenttype: {
				default: () => {
					return null
				}
			},
			moduleName: {
				default: () => {
					return null
				}
			},
			importpredata: {
				default: () => {
					return []
				}
			}
		},
		data() {
			return {
				maxlength:2000,
				list_autorender: false,
				moduleImporttemplate: [],
				importFields: [],
				importGridOptions: null,
				importNoticeShow: false,
				importSourceConfig:[],
				importConfig: [],
				importData: [],
				importTableRef: Math.random(),
				importLoading: false,
				importconfigid:0,
				importindex:0
			}
		},
		created() {

		},
	// 	computed: {
	// 		importconfig(){
	
	// 		}
	// 	},
		methods: {
			importpanel() {
				this.importNoticeShow = true
			},
			modalShow() {
				this.importinit()
			},
			modalHide(){
				this.list_gridOptions = null
			},
			importcomfig() {
				return new Promise((reslove)=>{
					this.$api.module.moduleImporttemplate(this.componenttype, this.moduleName).then((res) => {
						if(res.code==400){
							this.importNoticeShow = false
							this.$message.error(res.msg)
							return
						}
						reslove(res)
					})
				})
			},
			importinit(){
				this.importLoading = true
				this.importcomfig().then((res)=>{
					this.importSourceConfig = JSON.parse(JSON.stringify(res))
					this.importConfig = res
					this.importConfig.forEach((item)=>{
						if(item.config == 'add'){
							item.configtext = '仅新增'
						}
						if(item.config == 'update'){
							item.configtext = '仅更新'
						}
						if(item.config == 'addupdate'){
							item.configtext = '新增并更新'
						}						
					})
					this.importconfigid = res[0].id
					this.importindex = 0
					this.init_formButton()
					let list_gridOptions = this.list_getOption()
					this.list_beforeCreateGrid(list_gridOptions)
					this.list_gridOptions = list_gridOptions
					if(this.importpredata.length){
						let importpredata = JSON.parse(JSON.stringify(this.importpredata))
						importpredata.forEach((obj)=>{
							for(let i in obj){
								if(i.endsWith('time')){
									obj[i] = (obj[i] < 1000000000000) ? obj[i]*1000 : obj[i]
								}
							}
						})
						setTimeout(()=>{								
							this.$refs[this.importTableRef].loadData(importpredata).then(()=>{
								this.importLoading = false
							})
						},0)
					}else{
						this.importLoading = false
					}
				},()=>{
					this.importLoading = false
				})
			},
			importconfigidChange(e){
				if(e){
					this.importindex = this.importConfig.findIndex((item)=>{
						return item.id == e
					})
					this.init_formButton()
					let list_gridOptions = this.list_getOption()
					this.list_beforeCreateGrid(list_gridOptions)
					this.list_gridOptions = list_gridOptions
				}
			},
			list_beforeCreateGrid(gridOptions) {
				gridOptions.height = 450
				gridOptions.columns = this.importConfig[this.importindex].columns.map((item) => {
					let title = item.title
					let suffix = ''
					if(item.tablename!='主表'){
						suffix = '<'+item.tablename+'>'						
					}
					if(item.config.includes('require') || item.config.includes('unique')){
						suffix += '[必填]'
					}
					title += suffix	
					//item.props.placeholder = '123'
					let name = item.name
					let props = item.props
					if(item.name == '$quote' || item.name == '$inputBUtton'){
						name = '$input'
						props = []
					}
					if(item.name == '$select'){
						props.allowCreate = true
					}
					if(item.name == '$department'){
						props.ismodal = false
					}
					if(item.name == '$staff'){
						props.ismodal = false
					}
					let obj = {
						field: item.field,
						title: title,
						suffix: suffix,
						minWidth:150,
						editRender:{
							name:name,
							props:props,
							events:{
								change: ({
									row,
									column
								},e) => {
									this.fieldValueChange(row,column,e)
								},
							}
						}
					}
					if(item.name == '$upload'){
						obj.editRender.defaultValue = []
					}
					return obj
				})
				
				gridOptions.columns.unshift({
					title: '',
					type:'checkbox',
					fixed: "left",
					width: 50
				},{
					title: '#',
					type:'seq',
					fixed: "left",
					width: 50
				})
				gridOptions.columns.push({
					field: 'importresult',
					title:'导入结果',
					fixed: "right",
					align: 'center',
					width: 100,
					// editRender:{
					// 	name:'$input',
					// 	props:[]
					// }
				})
				gridOptions.columns.push({
					title: '操作',
					fixed: "right",
					align: 'center',
					width: 65,
					slots: {
						default: ({row}) => {
							return [<el-button style="color:#F56C6C" type = "text" size = "mini" onClick = {() => {this.del(row)}}>删除</el-button>]
						}
					}
				})
				//console.log(gridOptions.columns)
				let editRules = {}
				this.importConfig[this.importindex].columns.forEach((item)=>{
					if(item.config.includes('require') || item.config.includes('unique')){
						editRules[item.field] = [{
							required:true
						}]
					}
					
				})
				//console.log(editRules)
				gridOptions.editRules = editRules
				
				gridOptions.toolbarConfig.buttons = [{
					name: '新增',
					status: 'primary',
					code: 'add'
				},{
					name: '导入数据',
					status: 'success',
					code: 'import'
				},{
					name: '导出模板',
					status: '',
					code: 'export'
				},{
					name: '模拟导入',
					status: '',
					code: 'simulateexport'
				}]
				let exportcolumns = gridOptions.columns.filter((item)=>{
					return item.field && item.field!='importresult'
				})
				exportcolumns = exportcolumns.map((item)=>{
					return item.field
				})
				gridOptions.exportConfig = {
					filename: this.importConfig[this.importindex].name + '导入模板',
					columns:exportcolumns,
					type: 'xlsx'
				},
				gridOptions.importConfig =  {
					types: ['xls', 'xlsx'],
					remote: true,
					importMethod:this.importMethod
				},
				gridOptions.formConfig = false
				gridOptions.treeConfig = false
			},
			add(){
				
				this.$refs[this.importTableRef].insert({})
			},
			del(row){
				this.$refs[this.importTableRef].remove(row)
			},
			fieldValueChange(row,column,e){
				let checkbox =  this.$refs[this.importTableRef].getCheckboxRecords()
				checkbox.forEach((item)=>{
					item[column.field] = e
				})
				console.log(row,column,e)
			},
			importMethod(e) {
				//this.importColumns = []
				this.importLoading = true
				this.importData = []
				let file = e.file
				let reader = new FileReader();
				reader.onload = (e) => {
					let data = e.target.result
					let workbook = this.$XLSX.read(data, {
						type: 'binary',
					})
					let sheetName = workbook.SheetNames[0];
					let worksheet = workbook.Sheets[sheetName]
					let jsonData = this.$XLSX.utils.sheet_to_json(worksheet,{ raw: false })
					console.log(worksheet,jsonData)
					let tablecolumns = this.$Lodash.groupBy(this.$refs[this.importTableRef].getColumns(),'title')
					if (jsonData.length != 0) {
						if(jsonData.length > this.maxlength){
							this.$message.error('一次导入不能超过'+this.maxlength+'条')
							this.importLoading = false
							return
						}
						this.$refs[this.importTableRef].reloadData([]).then(() => {
							let insertData = []
							jsonData.forEach((item) => {
								let obj = {}
								//console.log(jsonData,tablecolumns)
								//let columnno = 0
								for (let i in item) {
									if(tablecolumns[i]){
										let columns = tablecolumns[i][0]
										if( columns.editRender ){
											if(columns.editRender.name == '$emun'){
												obj[columns.field] = window.systemMethods.getEmunId(columns.editRender.props.name,item[i])
											}else if(columns.editRender.name == '$select'){
												let selectoptions = columns.editRender.props.selectoptions
												let options = selectoptions.find((optionsitem)=>{
													return optionsitem.label == item[i]
												})
												//console.log(options)
												if(options){
													obj[columns.field] = options.value
												}else{
													obj[columns.field] = 10
												}
												//console.log(selectoptions)
											}else if(columns.editRender.name == '$datePicker'){
												//console.log(item[i])
												if(this.importisNumeric(item[i]) &&  item[i] < 1000000000){
													item[i] = this.GMTdate2date(item[i])
												}
												
												//console.log(this.GMTdate2date(item[i]))
												obj[columns.field] = this.$Moment(item[i]).valueOf()
											}else if(columns.editRender.name.startsWith('$') && columns.editRender.props.moduleName){												
												if(!columns.editRender.name.startsWith('$input')){
													// console.log(columns.editRender.props.moduleName)
													if(window.systemMethods['get'+ columns.editRender.props.moduleName]){
														obj[columns.field] = window.systemMethods['get'+ columns.editRender.props.moduleName](item[i],'label')
													}
													
												}
											}else{
												obj[columns.field] = item[i]
											}									
										}else{
											obj[columns.field] = item[i]
										}										
									}
								}																
								//console.log(obj,123123)																				
								for(let i in tablecolumns){
									if(tablecolumns[i][0].field){
										if(obj[tablecolumns[i][0].field] === null || obj[tablecolumns[i][0].field] === undefined){
											obj[tablecolumns[i][0].field] = null
										}
									}
								}
								//console.log(obj)
								insertData.push(obj)
							})
							this.$refs[this.importTableRef].reloadData(insertData)
							//console.log(insertData)
							//this.$refs[this.importTableRef].insertAt(insertData)
						})
						this.importLoading = false
					} else {
						this.importLoading = false
						this.$message.error('暂无数据')
					}
				}
				reader.readAsBinaryString(file)


			},
			importGetTableData() {
				let tableData = this.$refs[this.importTableRef].getTableData().fullData
				//console.log(tableData)
				return tableData
			},
			importTitle2Code() {
				let newdata = []
				let data = this.importGetTableData()
				data.forEach((item) => {
					let temparr = {}
					for (let i in item) {
						let obj = this.moduleImporttemplate.find((temp) => {
							return temp.title === i
						})
						if (obj) {
							temparr[obj.code] = item[i]
						}
					}
					newdata.push(temparr)
				})
				return newdata
			},
			simulateexport(){
				this.importApi(1)
			},
			importApi(simulate) {
				let columns = this.importSourceConfig[this.importindex].columns
				let foreignkey = this.importSourceConfig[this.importindex].foreignkey
				let configtype = this.importSourceConfig[this.importindex].configtype
				let config = this.importSourceConfig[this.importindex].config
				let code = this.importSourceConfig[this.importindex].code
				let fullData = this.importGetTableData()
				let data = []
				if(fullData.length>this.maxlength){
					this.$message.error('一次导入不能超过'+ this.maxlength + '条')
					return
				}
				fullData.forEach((item)=>{
					let obj = {}
					columns.forEach((_item)=>{			
						if(Array.isArray(item[_item.field])){
							obj[_item.field] = JSON.stringify(item[_item.field])
						}else if(item[_item.field]){
							obj[_item.field] = String(item[_item.field])
						}

					})
					data.push(obj)
				})
				
				//console.log(data,columns)
				
				if (data.length != 0) {
					data.forEach((item)=>{
						for(let i in item){
							if(Array.isArray(item[i])){
								item[i] = JSON.stringify(item[i])
							}
						}
					})
					const ws = this.$XLSX.utils.json_to_sheet(data);
					const wb = this.$XLSX.utils.book_new();
					this.$XLSX.utils.book_append_sheet(wb, ws, "Sheet1");
					const binary = this.$XLSX.write(wb, {
						bookType: "csv",
						type: "string"
					});
					let formData = new FormData()
					formData.append('excle', new Blob([binary], {
						type: 'application/octet-stream'
					}), 'excle.csv')
					formData.append('columns', JSON.stringify(columns))
					formData.append('configtype', configtype)
					formData.append('config', config)
					formData.append('code', code)
					formData.append('simulate', simulate)
					if(foreignkey){
						formData.append('foreignkey', foreignkey)
					}
					
					
					this.importLoading = true
					this.moduleImport(formData).then((res)=>{
						let fullData = this.importGetTableData()
						fullData.forEach((item,index)=>{
							item.importresult = res[index]
						})
						fullData = fullData.filter((item)=>{
							return item.importresult
						})
						//console.log(fullData)
						this.$refs[this.importTableRef].reloadData(fullData)
						//this.$message.error('部分导入失败')	
						this.importLoading = false
						if(!fullData.length){
							this.$message.success('操作成功')
						}
						this.list.customreload()
					},()=>{
						this.importLoading = false
					})
				} else {
					this.$message.error('暂无数据')
				}
			},
			importisNumeric(value) {
				return (
					(typeof value === 'number' && !isNaN(value)) || // 基本类型数字
					(typeof value === 'string' && !isNaN(parseFloat(value))) // 字符串数字
				)
			},
			moduleImport(formData) {
				return new Promise((reslove,reject)=>{
					this.$api.module.moduleImport(this.componenttype, this.moduleName, formData).then((res)=>{
						reslove(res)
					},()=>{
						reject()
					})
				})				
			},
			
			importdelete(e) {
				this.$refs[this.importTableRef].remove(e)
			},
			importToolbarButtonClick(e) {
				if (e.code == 'add') {
					this.$refs[this.importTableRef].insertAt({}, -1)
				}
				if (e.code == 'revert') {
					this.$refs[this.importTableRef].revertData()
				}
				if (e.code == 'importtemplate') {
					this.importtemplate()
				}
				if (e.code == 'clear') {
					this.$refs[this.importTableRef].reloadData([])
				}
				if (e.code == 'exportdata') {
					let data = this.$refs[this.importTableRef].getTableData().fullData
					if (data.length != 0) {
						this.$refs[this.importTableRef].exportData({
							filename: '错误数据',
							type: 'xlsx'
						})
					} else {
						this.$message.error('暂无数据')
					}
				}
			},
			importtemplate() {
				this.$api.module.moduleImporttemplate(this.componenttype, this.moduleName).then((res) => {
					let a = document.createElement('a')
					a.setAttribute("href", window.config.importTemplate + res + '?v=' + Math.random())
					a.setAttribute("download", "")
					a.click()
				}, () => {

				})
			},
			headerCellStyle({
				column
			}) {
				if (column.params && column.params.unique) {
					return {
						backgroundColor: '#67C23A',
					}
				}
				if (column.params && column.params.require) {
					return {
						backgroundColor: '#F56C6C',
					}
				}
			},
			GMTdate2date(serial) {
				
				const startDate = new Date(1900, 0, 1); // 1900-01-01
				const days = serial - 1; // Excel 的 1 = 1900-01-01
				const milliseconds = days * 86400 * 1000; // 1 天 = 86400 秒 * 1000 毫秒
				const date = new Date(startDate.getTime() + milliseconds);
				// 修正 Excel 的 1900 闰年错误（Excel 错误地认为 1900 是闰年）
				//if (serial >= 60) date.setDate(date.getDate());
				//console.log(date)
				return date.toISOString().split('T')[0]
			},
			// GMTdate2date(serialNumber) {
				
			// 	const excelBaseDate = new Date(1900, 0, 1);
			// 	const days = serialNumber - 1; // Excel序列号需要减去1
			// 	const targetDate = new Date(excelBaseDate);
			// 	targetDate.setDate(targetDate.getDate() + days);
			// 	const formattedDate = targetDate.getFullYear() + "/" +
			// 		(String(targetDate.getMonth() + 1).padStart(2, '0')) + "/" +
			// 		(String(targetDate.getDate()).padStart(2, '0'));
			// 	return formattedDate;
			// }

		}
	}
</script>